import { useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { countryShortcut } from '../../src/api/countryShortcut';
import { formatCAZipCode } from '../../src/api/formatCAZipCode';
import { createLead } from '../api/api';
import { LeadCaptureCreatePayload, LeadFormValues } from '../types/types';

export const useLeadCreate = () => {
  const { token } = useParams<{ token: string }>();

  return useMutation({
    mutationFn: (values: LeadFormValues) => {
      const isCanada = values.country === 'Canada';
      const leadData = {
        first_name: values.capture_first_name.trim(),
        phone_number: values.capture_phone_number.trim(),
        email: values.capture_email?.trim(),
        last_name: values.capture_last_name?.trim(),
        service_details: values.capture_service_details?.trim(),
        how_did_you_hear_about_us: values.capture_how_did_you_hear_about_us?.trim(),
        frequency: values.capture_frequency?.trim(),
        custom_question_answer: values.capture_custom_question?.trim(),
        custom_question_answer_2: values.capture_custom_question_2?.trim(),
        custom_question_answer_3: values.capture_custom_question_3?.trim(),
        street: (values.addressLine1 || values.addressLine2)?.trim(),
        city: values.city?.trim(),
        state: values.state?.trim(),
        zip_code: (isCanada ? formatCAZipCode(values.zipCode) : values.zipCode)?.trim(),
        unit: values.addressLine2?.trim(),
        country: countryShortcut(values.country)?.trim(),
        consent: values.consent ?? false,
        attachments: values.attachments,
        single_select_question_answer_uuid: values.single_select_question,
      };
      // Filter out undefined or null values
      const filteredLeadData = Object.fromEntries(
        Object.entries(leadData).filter(([_, v]) => v !== null || v !== undefined)
      );
      return createLead(token, filteredLeadData as LeadCaptureCreatePayload);
    },
  });
};
